import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconGas: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="gas"><path d="M14.25 20.25H15.25M14.25 20.25V3.75H3.75V20.25M14.25 20.25H3.75M2.75 20.25H3.75M14.25 9.75H17.75V17.25H21.25V8L18.75 5.75M11.25 9.75H6.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconGas;
